module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_13_2.b4344b41.jpeg";